/**
 * Define icon sizes based on input const
 * */
import {IconSizeE} from "../../../models/enums";

export const calcSizeFromValue = (size?: IconSizeE) => {
    switch (size) {
        case IconSizeE.XS:
            return ({width: 12});
        case IconSizeE.S:
            return ({width: 26});
        case IconSizeE.M:
            return ({width: 28});
        case IconSizeE.L:
            return ({width: 32});
        case IconSizeE.XL:
            return ({width: 36});
        case IconSizeE.XXL:
            return ({width: 42});
        default: return null;
    }
};